import { atom } from 'jotai'

import { LpToken, TokenWithLogo } from '@cowprotocol/common-const'
import { atomWithPartialUpdate } from '@cowprotocol/common-utils'
import { Currency } from '@cowprotocol/currency'
import { ListState } from '@cowprotocol/tokens'
import { Command } from '@cowprotocol/types'

import { Nullish } from 'types'

import { Field } from 'legacy/state/types'

import { TradeType } from 'common/modules/tradeNavigation'

/**
 * Pending list toggle state.
 * Set when user tries to enable a restricted list and consent is required.
 */
export interface ListToToggle {
  list: ListState
  consentHash: string
}

export interface SelectTokenWidgetState {
  open: boolean
  field?: Field
  oppositeToken?: TokenWithLogo | LpToken | Currency
  selectedToken?: Nullish<Currency>
  selectedPoolAddress?: string
  tokenToImport?: TokenWithLogo
  listToImport?: ListState
  listToToggle?: ListToToggle
  onSelectToken?: (currency: Currency) => void
  onInputPressEnter?: Command
  selectedTargetChainId?: number
  tradeType?: TradeType
  forceOpen?: boolean
  // UI config
  standalone?: boolean
  displayLpTokenLists?: boolean
}

export const DEFAULT_SELECT_TOKEN_WIDGET_STATE: SelectTokenWidgetState = {
  open: false,
  field: undefined,
  selectedToken: undefined,
  onSelectToken: undefined,
  tokenToImport: undefined,
  listToImport: undefined,
  listToToggle: undefined,
  selectedPoolAddress: undefined,
  selectedTargetChainId: undefined,
  tradeType: undefined,
  forceOpen: false,
  standalone: false,
  displayLpTokenLists: false,
}

export const { atom: selectTokenWidgetAtom, updateAtom: updateSelectTokenWidgetAtom } = atomWithPartialUpdate(
  atom<SelectTokenWidgetState>(DEFAULT_SELECT_TOKEN_WIDGET_STATE),
)
